import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/Auth-Slice'
import bookingReducer from './features/Booking-Slice'
import serviceMessageReducer from './features/ServiceMessage-Slice'
import storage from 'redux-persist/lib/storage';
import { FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';

const persistConfig = {
    key: "root",
    version: 1,
    storage
};

const reducer = combineReducers({
    auth: authReducer,
    serviceMessages: serviceMessageReducer,
    booking: bookingReducer
});

const persistedReducer = persistReducer(persistConfig, reducer);


export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;